export enum GatewayStatusEnum {
  FLASHED = "FLASHED",
  PROVISIONED = "PROVISIONED",
  NET_CONFIGURED = "NET_CONFIGURED",
  CONFIG_NEEDS_UPDATING = "CONFIG_NEEDS_UPDATING",
  UPDATING_CONFIG = "UPDATING_CONFIG",
  CONFIG_ERROR = "CONFIG_ERROR",
  DEVICES_CONFIGURED = "DEVICES_CONFIGURED",
  DISMISSION_ERROR = "DISMISSION_ERROR"
}
